import axios from 'axios'
import { NODE_BASE_URL, getAxiosOptions } from '../serviceHelper'

export const workflowService = {
  getActivities: async (user, processTemplateId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/admin/workflow/activities/${processTemplateId}`,
        getAxiosOptions(user)
      )
    ).data
  },
  getRoutes: async (user, activityTemplateId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/admin/workflow/routes/${activityTemplateId}`,
        getAxiosOptions(user)
      )
    ).data
  },
  createRoute: async (user, routeActivityMap, routeTemplate) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/admin/workflow/create-route`,
        { routeActivityMap, routeTemplate },
        getAxiosOptions(user)
      )
    ).data
  },
  updateRouteTemplate: async (user, routeTemplateId, routeTemplate) => {
    return (
      await axios.put(
        `${NODE_BASE_URL}/admin/workflow/update-route-template/${routeTemplateId}`,
        routeTemplate,
        getAxiosOptions(user)
      )
    ).data
  },
  updateRouteMap: async (user, data) => {
    return (
      await axios.put(
        `${NODE_BASE_URL}/admin/workflow/update-route-map`,
        data,
        getAxiosOptions(user)
      )
    ).data
  },
  deleteRoute: async (user, from, to) => {
    return (
      await axios.delete(
        `${NODE_BASE_URL}/admin/workflow/delete-route/${from}/${to}`,
        getAxiosOptions(user)
      )
    ).data
  },

  /* activity route */
  createActivityTemplate: async (user, activityTemplate) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/admin/workflow/create-activity-template`,
        activityTemplate,
        getAxiosOptions(user)
      )
    ).data
  },
  deleteActivityTemplate: async (user, templateId) => {
    return (
      await axios.delete(
        `${NODE_BASE_URL}/admin/workflow/delete-activity-template/${templateId}`,
        getAxiosOptions(user)
      )
    ).data
  },
  updateActivityTemplateMetadata: async (user, metadata) => {
    return (
      await axios.put(
        `${NODE_BASE_URL}/admin/workflow/update-activity-workflow-metadata/${user.id}`,
        metadata,
        getAxiosOptions(user)
      )
    ).data
  },
  setHiddenRouteTeamMap: async (user, routeTemplateId, data) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/admin/route/${routeTemplateId}`,
        data,
        getAxiosOptions(user)
      )
    ).data
  },
  getHiddenRouteTeamMap: async (user, routeTemplateId) => {
    return (
      await axios.get(`${NODE_BASE_URL}/admin/route/${routeTemplateId}`, getAxiosOptions(user))
    ).data
  },
}
